const Holiday = () =>
  import(
    /* webpackChunkName: "base-info-calendar-holiday" */ '@/pages/base-info/calendar/holiday/index.vue'
  )
const CreateHoliday = () =>
  import(
    /* webpackChunkName: "base-info-calendar-holiday" */ '@/pages/base-info/calendar/holiday/create.vue'
  )
const EditHoliday = () =>
  import(
    /* webpackChunkName: "base-info-calendar-holiday" */ '@/pages/base-info/calendar/holiday/edit.vue'
  )

export default {
  path: 'holiday',
  meta: {
    label: 'holiday',
    auth: 'holiday'
  },
  component: {
    name: 'Holiday',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoCalendarHoliday',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Holiday
    },
    {
      name: 'BaseInfoCreateCalendarHoliday',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateHoliday
    },
    {
      name: 'BaseInfoEditCalendarHoliday',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditHoliday,
      props: true
    }
  ]
}
